import React, { useState } from 'react';
import '../css/WhatsAppButton.css';

const WHATSAPP_NUMBER = '919834438510'; // +91 94269 59368

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  const message = encodeURIComponent(
    'Hi! I am interested in a property from Prathamesh Developers. Can you please share more details?'
  );
  const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${hovered ? 'hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      id="whatsapp-fab-btn"
    >
      <span className={`whatsapp-label ${hovered ? 'visible' : ''}`}>
        Chat with us!
      </span>
      <i className="fab fa-whatsapp whatsapp-icon"></i>
    </a>
  );
};

export default WhatsAppButton;
